import { Citation } from '#/api'

export type Chip = {
  id: string
  displayValue: string
  hintValueDisplay: string
}

export const convertCitationToChips = (citation: Citation): Chip[] => {
  const chips: Chip[] = []

  if (citation.documentNumber) {
    chips.push({
      id: `${citation.id}-dn`,
      displayValue: `Id: ${citation.documentNumber}`,
      hintValueDisplay: `Document number: ${citation.documentNumber}`
    })
  }

  if (citation.partId) {
    chips.push({
      id: `${citation.id}-pid`,
      displayValue: `Pid: ${citation.partId}`,
      hintValueDisplay: `Part Id: ${citation.partId}`
    })
  }

  if (citation.revision) {
    chips.push({
      id: `${citation.id}-rev`,
      displayValue: `Rev: ${citation.revision}`,
      hintValueDisplay: `Revision: ${citation.revision}`
    })
  }

  if (citation.languageCode) {
    chips.push({
      id: `${citation.id}-lng`,
      displayValue: `Lng: ${citation.languageCode}`,
      hintValueDisplay: `Language code: ${citation.languageCode}`
    })
  }

  if (citation.fileExtension) {
    chips.push({
      id: `${citation.id}-ext`,
      displayValue: `Ext: ${citation.fileExtension.toUpperCase()}`,
      hintValueDisplay: `File extension: ${citation.fileExtension.toUpperCase()}`
    })
  }

  // For PDF files we are using pages
  if (citation.fileExtension === 'pdf' && citation.page_from && citation.page_to) {
    let displayValue = `Page: ${citation.page_from} - ${citation.page_to}`
    let hintValueDisplay = `Page: ${citation.page_from} - ${citation.page_to}`

    if (citation.page_from == citation.page_to) {
      displayValue = `Page: ${citation.page_from}`
      hintValueDisplay = `Page: ${citation.page_from}`
    }

    chips.push({
      id: `${citation.id}-page`,
      displayValue: displayValue,
      hintValueDisplay: hintValueDisplay
    })
  }

  // for non-PDF files, we are using snippets
  if (citation.fileExtension !== 'pdf' && citation.chunk_id) {
    chips.push({
      id: `${citation.id}-snip`,
      displayValue: `Snip: ${citation.chunk_id}`,
      hintValueDisplay: `Snippet: ${citation.chunk_id}`
    })
  }

  return chips
}
